import React from 'react'
import PropTypes from "prop-types"
import { connect } from 'react-redux'

import LogViewer from "./LogViewer"
import { docPageStyle } from '../containers/PageStyles'

const LogPage = ({ col, id }) => (
  <div className="activity-page" style={docPageStyle({maxWidth: 1050})}>
    <LogViewer id={id} col={col} includeTitle />
  </div>
)

LogPage.propTypes = {
  col: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}

const stateToProps = (_state, ownProps) => ({
  id: ownProps.routeParams.id,
  col: ownProps.routeParams.col,
})

export default connect(stateToProps)(LogPage)
